export default [
    {
        method: 'getSmsGenericSend',
        type: 'POST',
        path: '/web/sms/generic/send',
        mode: 'passport',
        params: ["cid", "tel", "type", "captcha"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '短信发送接口(无需登录态)'
    },
    {
        method: 'getSmsGenericCheck',
        type: 'POST',
        path: '/web/sms/generic/check',
        mode: 'passport',
        params: ["cid", "tel", "code", "type"],
        options: { cache: false },
        switch: false,
        // desc: '短信验证接口(无需登录态)'
    },
    {
        method: 'resetPwd',
        type: 'POST',
        path: '/web/reset/pwd',
        mode: 'passport',
        params: ["cid","tel","code","pwd","repeatPwd"],
        options: { cache: false },
        switch: false,
        // desc: '重置密码(无需登录态)'
    },
    {
        method: 'resetEmailPwd',
        type: 'POST',
        path: '/web/reset/pwd',
        mode: 'passport',
        params: ["user","captcha","pwd","rePwd"],
        options: { cache: false },
        switch: false,
        // desc: '邮箱重置密码(无需登录态)'
    },
    {
        method: 'sendEmailCode',
        type: 'POST',
        path: '/web/captcha/generic/send',
        mode: 'passport',
        params: ["user", "type", "captcha"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '找回密码发送邮箱验证码'
    },
    {
        method: 'checkEmailCode',
        type: 'POST',
        path: '/web/reset/email/check',
        mode: 'passport',
        params: ["user", "captcha", "changeBaseUrl"],
        options: { cache: false },
        switch: false,
        // desc: '邮箱验证码验证接口(无需登录态)'
    },
    {
        method: "getResetPublicKey",
        type: 'GET',
        path: '/web/rsa_public',
        mode: 'passport',
        params: ["changeBaseUrl"],
        options: { cache: false },
        switch: true,
        // desc: '邮箱重置密码获取public_ley'
    },
    {
        method: 'checkEmailLink',
        type: 'POST',
        path: '/web/email/mail.check',
        mode: 'passport',
        params: ["email_ticket", "email", "email_type", "changeBaseUrl"],
        options: { withCredentials: true, cache: false },
        switch: true,
        // desc: '校验是否点击了邮箱链接'
    },
    {
        method: 'resetNewEmailPwd',
        type: 'POST',
        path: '/web/email/reset.email',
        mode: 'passport',
        params: ["email_ticket", "pwd", "re_pwd", "changeBaseUrl"],
        options: { withCredentials: true, cache: false },
        switch: true,
        // desc: '重置邮箱帐号密码'
    }
];